// extracted by mini-css-extract-plugin
module.exports = {"toggleLabel":"GfeToggle_toggleLabel__3uxHx"};